var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStat1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 100,
    viewBox: "0 0 109 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_140_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78433 100C4.78433 100 2.02398 98.0681 1.0259 96.2542C-1.89576 90.9444 2.07828 81.7052 4.78433 76.9902C17.8776 54.1768 50.2682 54.2691 63.3084 76.9902C66.1847 82.0017 69.5982 90.526 67.0669 96.2542C66.3399 97.8994 64.3823 100 64.3823 100H4.78433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.355 22.9436C13.457 30.248 13.457 41.3245 20.355 48.6289C27.684 56.3898 40.4087 56.3898 47.7378 48.6289C54.6357 41.3245 54.6357 30.248 47.7378 22.9436C40.4087 15.1827 27.684 15.1827 20.355 22.9436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0331 54.5154C52.0331 54.5154 57.5567 57.0135 60.6238 59.3314C63.6955 61.6528 65.242 63.2515 67.6038 66.2879C70.5361 70.0577 73.5099 76.9902 73.5099 76.9902H105.188C105.188 76.9902 107.163 75.6119 107.873 74.3147C110.315 69.8515 107.873 58.2609 105.188 54.5154C92.2132 36.413 65.4561 36.3217 52.0331 54.5154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3823 5.82068C57.4843 13.1251 57.4843 24.2016 64.3823 31.506C71.7113 39.2669 84.4361 39.2669 91.7651 31.506C98.6631 24.2016 98.6631 13.1251 91.7651 5.82068C84.4361 -1.94023 71.7113 -1.94023 64.3823 5.82068Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_140_256",
    x: 0,
    y: 0,
    width: 108.878,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_140_256"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat1);
export default __webpack_public_path__ + "static/media/stat1.75164ed9821812ff8a676ea27966d9c1.svg";
export { ForwardRef as ReactComponent };